import React from 'react';

import mainImage from 'asset/phone_black.png';
import Bowser from 'bowser';
import cn from 'classnames';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';

import { Blocker, Triangle } from './framer.icons';

export default function Hero2() {
  let isApple = window.navigator.vendor.toLowerCase().indexOf('apple') > -1;
  const browser = Bowser.getParser(window.navigator.userAgent);
  const isSafari = browser.getBrowserName() === 'Safari';

  return (
    <section
      className={cn(
        'hero gl-wrapper-y blocker-activator relative flex min-h-[100vh] items-center overflow-hidden pt-[11rem] min-2xl:pb-[7.5rem]',
      )}
    >
      <div className="gl-wrapper insane-blocker relative flex gap-7">
        <div className="flex h-full max-w-[60%] flex-col gap-8 1100:!max-w-full 1300:max-w-[50%] lg:max-w-full lg:gap-6">
          <h1 className="font-Proxima text-[3.75rem] font-black uppercase leading-tight text-white lg:text-[48px] sm:text-[32px] [&>span]:text-demo-sa-green">
            Your AI-Powered Personal Shopper <br />
            <span>Online, In-Store, Anytime</span>
          </h1>

          <img
            className="floating-image relative z-[8] mx-auto h-full w-full object-contain min-sm:hidden lg:max-w-[40vw] sm:block"
            src={mainImage}
          />

          <div className="flex gap-5">
            <div className="flex flex-col gap-7">
              <div className="relative pt-[1.25rem] text-white before:absolute before:top-0 before:h-[2px] before:w-[8rem] before:bg-white 1300:z-[100]">
                Shopping should be effortless. The SoftServe Gen AI Retail Shopping Assistant, built with NVIDIA AI
                Blueprints, delivers a seamless shopping experience with AI-driven search, instant recommendations, and
                real-time virtual try-ons. <br />
                <br />
                With just a quick snap from their phone or computer camera, customers can see how products look on their
                own image, no more guessing. The AI assistant personalizes product discovery, eliminates purchase
                hesitation, and helps retailers reduce return rates.
              </div>
              <Link
                to="contact-us"
                className="flex w-fit cursor-pointer items-center justify-center bg-demo-sa-green px-[2.25rem] py-[0.875rem] font-Proxima font-black uppercase text-white hover:border-demo-sa-green hover:bg-white hover:text-demo-sa-green 1300:z-[100]"
              >
                Book a demo
              </Link>
            </div>

            <img
              className="floating-image relative z-[8] h-full w-full object-contain min-lg:hidden lg:block lg:max-w-[20vw] sm:hidden"
              src={mainImage}
            />
          </div>
        </div>

        <div className="relative max-h-[37.5rem] 1100:hidden 1300:min-w-[514px] lg:hidden">
          <motion.img
            initial={{ y: '45rem' }}
            animate={{
              y: '0',
            }}
            transition={{ duration: 1.5, delay: 2.25 }}
            className="floating-image relative z-[8] h-full w-full object-contain"
            src={mainImage}
          />
          <Triangle
            isStatic={isSafari || isApple}
            className="absolute bottom-[-9.375rem] left-[-10%] w-[calc(100%+120px)] rotate-180"
          />
          <Blocker
            isStatic={isSafari || isApple}
            className="absolute bottom-[-20.0455rem] left-[-10%] z-10 w-[calc(100%+120px)] rotate-180 bg-transparent 1300:bottom-[-342px] min-2xl:bottom-[-19.3rem] 1300:[&>path]:min-h-[150px]"
          />
        </div>

        <img
          className="floating-image min-1100:hidden relative z-[8] h-full w-full object-contain delay-0 1100:block 1100:max-w-[30vw] lg:hidden sm:hidden"
          src={mainImage}
        />
      </div>
    </section>
  );
}
